// Data access for the client portal's billing screens — the tenant-scoped
// /billing endpoints (tenant identity always comes from the JWT server-side).
import type { BillingForecast, BillingSummary, Invoice, InvoiceWithLines } from "@pgs-core/types";
import type { ApiClient } from "./api";

export function fetchBillingSummary(api: ApiClient): Promise<BillingSummary> {
  return api.request<BillingSummary>("/billing/summary");
}

export function fetchBillingForecast(api: ApiClient): Promise<BillingForecast> {
  return api.request<BillingForecast>("/billing/forecast");
}

export function fetchInvoices(api: ApiClient): Promise<{ invoices: Invoice[] }> {
  return api.request<{ invoices: Invoice[] }>("/billing/invoices");
}

export function fetchInvoice(api: ApiClient, invoiceId: string): Promise<{ invoice: InvoiceWithLines }> {
  return api.request<{ invoice: InvoiceWithLines }>(`/billing/invoices/${encodeURIComponent(invoiceId)}`);
}

export function invoiceHtmlPath(invoiceId: string): string {
  return `/billing/invoices/${encodeURIComponent(invoiceId)}/html`;
}

/** Start the GoCardless mandate setup/fix flow; caller redirects to the URL. */
export function startMandateFlow(
  api: ApiClient,
  successRedirectUrl: string
): Promise<{ redirect_flow_id: string; redirect_url: string }> {
  return api.request("/billing/mandate/redirect-flow", {
    method: "POST",
    body: JSON.stringify({ success_redirect_url: successRedirectUrl }),
  });
}

/** Complete the flow after GoCardless bounces back with ?redirect_flow_id=…. */
export function completeMandateFlow(
  api: ApiClient,
  redirectFlowId: string
): Promise<{ mandate_id: string; billing_status: string }> {
  return api.request("/billing/mandate/redirect-flow/complete", {
    method: "POST",
    body: JSON.stringify({ redirect_flow_id: redirectFlowId }),
  });
}
